import MaterialPage from "@/views/material/MaterialPage.vue";
import api from "@/api";
export default {
  name: "DashboardView",
  components: {
    MaterialPage
  },
  data() {
    return {
      permissions: []
    };
  },
  computed: {
    boomType() {
      return this.$route.params.boomType == 1;
    }
  },
  methods: {
    init() {
      api.getUserInfo().then(ret => {
        this.permissions = ret.permissions;
      });
    }
  },
  mounted() {
    this.init();
  }
};